require 'angular'

angular.module('workflow.api', ['ngResource', 'workflow.settings'])

require './config'
require './services'
